/**
 * ©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
 * Bangalore, India. All Rights Reserved.
 */
import {
  PolymerElement,
  html
} from "@polymer/polymer/polymer-element.js";
import {
  mixinBehaviors
} from "@polymer/polymer/lib/legacy/class.js";
import '../behaviors/log-out-behaviour.js';
import '../behaviors/mpin-register-behaviour.js';

class mpinSignOnPassword extends mixinBehaviors([corpBehaviours.logOutBehaviour, corpBehaviours.mpinRegisterBehaviour], PolymerElement) {
  /** Properties definition*/
  static get properties() {
    return {
      selectedPage: {
        type: Number,
        notify: true,
        observer: 'SignOnHeaderFocus'
      },
      selected: {
        type: Number,
        notify: true
      },
      phone: {
        type: String,
        notify: true,
        observer: 'changeStyle'
      },
      profilePage: {
        type: Boolean,
        value: false,
        notify: true
      },
      mpinAuthList: {
        type: Object,
        notify: true
      }
    };
  }
  /** HTML template definition*/


  static get template() {
    return html `
        <style include="app-styles">
        .banner-skew[phone] {
            top: 7.5vw;
        }
    </style>
        
    <app-media-query phone="{{phone}}" tablet="{{tablet}}" desktop="{{desktop}}"></app-media-query>
    <oe-ajax id="logoutAjax" method="post" content-type="application/json" body="{{objData}}" on-response="_handleResponse" on-error="_handleError"></oe-ajax>
    <div class="mdl-grid mdl-grid--no-spacing" phone$="{{phone}}">

        <div class="mdl-cell--8-col mdl-cell--6-col-desktop position-relative">
          
            <div class="banner-skew banner-brand full-width mdl-cell--hide-tablet" phone$="{{phone}}"></div>
            <div class="root-container mdl-grid mdl-right-no-spacing-phone">

                <div class="mdl-grid mdl-cell mdl-cell--hide-tablet position-relative mdl-cell--1-offset-desktop mdl-grid--no-spacing">
                  
                <div class="mdl-grid  mdl-cell--12-col-desktop mdl-cell"></div>
                <div class="mdl-grid  mdl-cell--12-col-desktop mdl-cell"></div>
                    <div class="mdl-grid mdl-cell--12-col-desktop mdl-cell"></div>
                    <div class="outlineOffset mdl-grid mdl-cell--12-col-desktop mdl-cell" role="heading" aria-level="2" id="SignOnHeader" tabindex="0">
                      <oe-i18n-msg class="primary-light-text-xl mdl-cell--12-col-desktop" msgid="h_Authentication"></oe-i18n-msg>
                   </div>
                    <div class="mdl-grid mdl-cell--12-col-desktop mdl-cell"></div>
                    <div class="mdl-grid mdl-cell--12-col-desktop mdl-cell"></div>
                    <div class="mdl-grid mdl-cell--12-col-desktop mdl-cell"></div>
                </div>
             

                <!--for desktop view only-->
                <div class="main-container mdl-cell--1-offset-tablet mdl-cell--6-col-tablet mdl-cell--1-offset-desktop mdl-cell--9-col-desktop mdl-cell"
                    wide-layout$="{{wide}}" extra-wide-layout$="{{extra-wide}}">
                   
                   <div class="mdl-cell margin-l-zero"> 
                   <oe-input id="signOnPasswordId" label="l_Password" type="password" class="light-input-style" value="{{signOnPassword}}" 
                   required="{{required}}">
                        
                   </oe-input>
                    </div>
                    <!--for desktop view only-->
                    <div class="btn align-end full-width">
                    <div class="mdl-grid mdl-cell--12-col-desktop mdl-cell"></div>
                    <div class="mdl-grid mdl-cell--12-col-desktop mdl-cell"></div>
                    <div class="mdl-grid mdl-cell--12-col-desktop mdl-cell"></div>
                        <div class="mdl-grid mdl-cell mdl-cell--12-col-desktop mdl-grid--no-spacing margin-zero">
                            <paper-button id="prepwdCancel" class="secondary-button" on-tap="clearFields" raised>
                                <oe-i18n-msg class="" msgid="b_Cancel"></oe-i18n-msg>
                            </paper-button>

                            <paper-button id="prepwdProceed" class="primary-button" raised on-tap="gotoNextPage">
                                <oe-i18n-msg msgid="b_Continue"></oe-i18n-msg>
                            </paper-button>
                        </div>
                        <div class="mdl-cell mdl-grid"></div>
                        <div class="mdl-grid"></div>
                        <div class="mdl-grid"></div>
                        <div class="mdl-grid"></div>
                        <div class="mdl-grid"></div>       
                    </div>
                </div>
            </div>
        </div>
    </div>`;
  }
  clearFields() {
    if (!this.profilePage) this.goToLoginPage();
    else {
      this.backToMyProfile();
    }
  }
  changeStyle() {
    this.updateStyles();
  }
  gotoNextPage() {
    if (!this.signOnPassword) {
      this.fire("oe-show-error", getLabel('m_PleaseEnterPassword'));
      return false;
    } else {
      if (this.signOnPassword) {
        if (this.mpinAuthList && this.mpinAuthList.authenticationDetails && this.mpinAuthList.authenticationDetails.signOnPassword) this.authorizationDetailsBody.signOnPassword = {
          "signOnPassword": this.signOnPassword
        };
        this.enabledAuthList.shift();
        if (this.enabledAuthList.length > 0) this.selectedPage = this.authPage[this.enabledAuthList[0]];
        else this.postRequest();
      }
    }
  }
  SignOnHeaderFocus() {
    if (this.selectedPage == 4) {
      // this.$.SignOnHeader.focus();
      this.$$("#SignOnHeader").focus();
    }
  }
}

customElements.define('mpin-sign-on-password', mpinSignOnPassword);